import React from "react";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalClose.module.scss";
import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

interface ModalCloseProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
}

export const ModalClose: React.FC<ModalCloseProps> = ({
  children,
  className = "",
  ...rest
}) => {
  const { setOpen } = useModal();
  const { getIcon } = useGlobalContext();

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    rest.onClick?.(e);
  };

  return (
    <button
      type="button"
      onClick={handleClose}
      className={`${styles["modal-close-btn"]} ${className}`.trim()}
      {...rest}
    >
      {children ?? (
        <ReactSVG
          src={getIcon("close")}
          wrapper={"svg"}
          width={32}
          height={32}
        />
      )}
    </button>
  );
};
